import "../../../assets/RideSelect.css";
import l, { forwardRef as ne, useState as p, useRef as N, useImperativeHandle as se, useEffect as I, cloneElement as oe } from "react";
import C from "clsx";
import { RideGlDown as ce } from "../graphic/glyph/components/RideGlDown.js";
import { RideSelectMenu as ue } from "../select-menu/RideSelectMenu.js";
import { RideErrorMessage as de } from "../error-message/RideErrorMessage.js";
import M from "lodash.uniqueid";
import { fireEvent as _e } from "../../../utils/events.js";
import { RideSpinner as me } from "../spinner/RideSpinner.js";
const fe = "_label_1ul3i_60", pe = "_optional_1ul3i_72", he = "_placeholder_1ul3i_120", be = "_active_1ul3i_128", ge = "_spinner_1ul3i_138", we = "_combobox_1ul3i_141", Ee = "_disabled_1ul3i_144", ye = "_loading_1ul3i_144", xe = "_graphic_1ul3i_167", ve = "_error_1ul3i_170", Ne = "_medium_1ul3i_204", Ce = "_large_1ul3i_211", Re = "_dropdown_1ul3i_219", ke = "_rotate_1ul3i_1", t = {
  "ride-select": "_ride-select_1ul3i_54",
  label: fe,
  optional: pe,
  "select-hidden": "_select-hidden_1ul3i_80",
  "select-button": "_select-button_1ul3i_83",
  "select-text": "_select-text_1ul3i_101",
  placeholder: he,
  active: be,
  "glyph-arrow": "_glyph-arrow_1ul3i_135",
  spinner: ge,
  combobox: we,
  disabled: Ee,
  loading: ye,
  "helper-text": "_helper-text_1ul3i_164",
  graphic: xe,
  error: ve,
  medium: Ne,
  large: Ce,
  dropdown: Re,
  "fade-in": "_fade-in_1ul3i_1",
  "fade-out": "_fade-out_1ul3i_1",
  rotate: ke,
  "slide-in-up": "_slide-in-up_1ul3i_1",
  "slide-in-down": "_slide-in-down_1ul3i_1",
  "fill-center-out": "_fill-center-out_1ul3i_1"
}, qe = ne(
  ({
    "aria-label": A,
    "aria-required": b,
    "aria-labelledby": K,
    id: U,
    className: $,
    "data-testid": j,
    "data-menu-testid": H,
    disabled: s,
    error: R,
    errorMessage: k,
    helperText: q,
    informativePopover: D,
    label: g,
    loading: o,
    loadingMenu: L,
    multiple: m,
    name: F,
    onBlur: w,
    onChange: J,
    onOpenChange: E,
    onSelect: i,
    options: O,
    required: T,
    showCheckbox: P,
    size: Q = "medium",
    value: V
  }, W) => {
    const [z, y] = p(""), [B, x] = p(null), [c, u] = p(!1), [v] = p(U ?? M(":ride:")), [G] = p(M(":ride:")), h = N(null), d = N(null), _ = N(null);
    se(W, () => d.current), I(() => {
      u(!1);
    }, [o, s]), I(() => {
      E == null || E(c);
    }, [c]);
    const X = () => {
      h.current && h.current.focus(), u((e) => !e);
    }, Y = () => {
      if (!s && R && k)
        return /* @__PURE__ */ l.createElement(de, { message: k });
      if (q)
        return /* @__PURE__ */ l.createElement("p", { className: t["helper-text"] }, q);
    }, Z = () => C($, t["ride-select"], t[Q], {
      [t.disabled]: s,
      [t.loading]: o,
      [t.error]: !s && !o && R
    }), S = () => C(t["select-text"], {
      [t.placeholder]: !z
    }), ee = () => D ? oe(D, { size: "small" }) : null, te = (e, a) => {
      if (d != null && d.current) {
        const r = e.map(
          (n) => n.value.toString()
        );
        for (const n of d.current.options)
          n.selected = r.includes(n.value);
        a === "onChange" && _e(d.current, "change");
      }
      if (e.length === 0) {
        y(""), x(null), a === "onChange" && (m ? i == null || i([]) : i == null || i({}));
        return;
      }
      if (m)
        y(e.map((r) => r.label).join(", ")), x(null), a === "onChange" && (i == null || i(e));
      else {
        const r = e[0];
        y(r.label), x(r == null ? void 0 : r.graphic), a === "onChange" && (i == null || i(r));
      }
    }, re = (e, a) => {
      te(e, a);
    }, le = () => C(t["select-button"], {
      [t.active]: c
    }), ae = (e) => {
      e.code === "Tab" && c ? (e.preventDefault(), u(!1)) : e.code === "Escape" ? u(!1) : e.code === "ArrowDown" ? (e.preventDefault(), u(!0), setTimeout(() => {
        var a, r, n, f;
        (a = _.current) != null && a.querySelector("li:has(:checked)") ? ((r = _.current) == null ? void 0 : r.querySelector(
          "li:has(:checked)"
        )).focus() : (f = (n = _.current) == null ? void 0 : n.querySelector("li")) == null || f.focus();
      })) : e.code === "ArrowUp" && (e.preventDefault(), u(!0), setTimeout(() => {
        var a, r, n, f;
        (a = _.current) != null && a.querySelector("li:has(:checked)") ? ((r = _.current) == null ? void 0 : r.querySelector(
          "li:has(:checked)"
        )).focus() : (f = (n = _.current) == null ? void 0 : n.querySelector("li:last-child")) == null || f.focus();
      }));
    }, ie = (e) => {
      c || w == null || w(e);
    };
    return /* @__PURE__ */ l.createElement("div", { "data-testid": j, className: Z() }, /* @__PURE__ */ l.createElement(
      "select",
      {
        ref: d,
        onChange: J,
        name: F,
        className: t["select-hidden"],
        required: T,
        disabled: s,
        "aria-required": b,
        multiple: m,
        "aria-hidden": "true"
      },
      /* @__PURE__ */ l.createElement("option", null),
      O.map((e, a) => /* @__PURE__ */ l.createElement("option", { key: a, value: e.value }, e.label))
    ), g && /* @__PURE__ */ l.createElement("label", { className: t.label, id: G }, g, !(T || b) && /* @__PURE__ */ l.createElement("span", { className: t.optional }, "(opcional)"), ee()), /* @__PURE__ */ l.createElement(
      "button",
      {
        className: le(),
        "aria-busy": !s && o ? "true" : "false",
        "aria-controls": `${v}:select-dropdown`,
        "aria-expanded": c ? "true" : "false",
        "aria-label": A,
        "aria-required": b,
        "aria-labelledby": g ? G : K,
        disabled: s || o,
        id: v,
        role: "combobox",
        onClick: X,
        ref: h,
        onBlur: ie,
        type: "button",
        onKeyDown: ae
      },
      !m && B && /* @__PURE__ */ l.createElement("div", { className: t.graphic }, B),
      /* @__PURE__ */ l.createElement("span", { className: S() }, z || "Elige una opción"),
      !o && /* @__PURE__ */ l.createElement("div", { className: t["glyph-arrow"] }, /* @__PURE__ */ l.createElement(ce, { size: "large", fill: "currentColor" })),
      o && /* @__PURE__ */ l.createElement(me, { className: t.spinner, size: "large" })
    ), /* @__PURE__ */ l.createElement(
      ue,
      {
        "data-testid": H,
        isOpen: c,
        loading: L,
        messageEmptyOptions: "Sin opciones",
        multiple: m,
        showCheckbox: P,
        onOpenChange: u,
        onOptionsSelected: re,
        options: O,
        triggerRef: h,
        ref: _,
        value: V,
        id: `${v}:select-dropdown`
      }
    ), Y());
  }
);
qe.displayName = "RideSelect";
export {
  qe as RideSelect
};
